import { Component, OnInit, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompanyAddress } from 'src/shared/api';
import { FormConfig } from '../../form-cva.component';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';

export const companyAddressFormConfig: FormConfig<Required<CompanyAddress>> = {
	id: [''],
	address: [null],
	isDefault: [false],
};

@Component({
	selector: 'rpshared-company-address-dialog',
	templateUrl: './company-address-dialog.component.html',
})
export class CompanyAddressDialogComponent extends SelfDestruct implements OnInit {
	form = this.fb.group(companyAddressFormConfig) as FormGroup;

	constructor(
		@Inject(MAT_DIALOG_DATA) @Optional() private readonly companyAddress: CompanyAddress,
		private readonly fb: FormBuilder
	) {
		super();
	}

	ngOnInit() {
		if (this.companyAddress) {
			this.form.setValue(this.companyAddress, { emitEvent: false });
		}
	}
}
